import { Avatar } from "@material-ui/core";
import React, { useState, useEffect, useRef } from "react";
import { styled } from "@material-ui/styles";
import { Button } from "reactstrap";
import moment from "moment";
import axios from "../../axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import Toolbar, { modules, formats } from "./Toolbar";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import updatemoment from "./updatemoment";
import Unassigned from "../../assets/images/avatar.png";

function ManagerNotesupdate({
  showForm,
  setShowForm,
  refreshTrigger,
  clientId,
  releaseid,
}) {
  const date = moment().utcOffset("+05:30").format("YYYY-MM-DDTHH:mm:ss");
  let User_details = JSON.parse(localStorage.getItem("Empdetails"));
  let managerid = JSON.parse(localStorage.getItem("managerid"));

  const { allImage, IsMinimised, projectRole, employeeList, userImage } =
    useSelector((state) => state.user);
  // console.log(employeeList);
  // console.log(userImage);
  const { data, isSuccess, message, loading, currentsprintdata } = useSelector(
    (state) => state.note
  );

  let productRole = JSON.parse(localStorage.getItem("ProductRole"));
  const getProdRole = productRole?.filter((e) => e.ProdId == "11004")[0]
    ?.RoleCode;
  const [notesupdate, setNotesUpdate] = useState("");
  const [updatednotedata, setUpdatednotedata] = useState([]);
  const [inputopen, setInputopen] = useState(true);

  // const [releaseId, setReleaseId] = useState();
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  let userdetails = JSON.parse(localStorage.getItem("clientdetails"));
  const userorg = userdetails?.[0]?.OrgDetails;
  let emplogin = JSON.parse(localStorage.getItem("Empdetails"));
  let clientid = JSON.parse(localStorage.getItem("clientid"));
  const BootstrapButton = styled(Button)({
    textTransform: "none",
    fontSize: 13,
    padding: "6px 12px",
    margin: 10,
    border: "0px solid",
  });
  // const employeeList = [];
  // console.log(employeeList);

  const emailmembers = employeeList
    ?.filter((e) => e.email)
    ?.map((e) => e.email);

  // console.log(emailmembers);

  function Refresh_API_data() {
    // console.log(ReleaseId, "release id");
    axios
      .get("agilesaas_releases?ReleaseId=eq." + releaseid)
      .then((res) => {
        setUpdatednotedata(res?.data?.[0]?.ManagerNotes);
        // console.log(res?.data, "res?.data?.[0]?.ReleaseId");
        // setReleaseId(res?.data?.[0]?.ReleaseId);
      })
      .catch((e) => {
        setUpdatednotedata([]);
        console.log(e);
      });
  }

  useEffect(() => {
    Refresh_API_data();
  }, []);

  function Submit_data(e) {
    // console.log("called submit data", notesupdate);
    e.preventDefault();
    try {
      if (notesupdate != "") {
        let r =
          updatednotedata == null ||
          updatednotedata == undefined ||
          updatednotedata.length === 0
            ? 1
            : parseInt(
                updatednotedata?.sort((a, b) => b?.noteNo - a?.noteNo)[0]
                  ?.noteNo + 1
              );

        let data;
        if (edit) {
          data = {
            ManagerNotes: updatednotedata.map((item) => {
              if (item.noteNo === editData) {
                return { ...item, notes: notesupdate };
              }
              return item;
            }),
          };
          setNotesUpdate("");
          setEdit(false);
        } else {
          data = {
            ManagerNotes: [
              ...(updatednotedata ? updatednotedata : []),
              {
                UpdatedBy: User_details[0].ClientUserId,
                UpdatedByDetails: {
                  FN: User_details[0].UserFirstname,
                  LN: User_details[0].UserLastname,
                },
                noteNo: r,
                managername: "Yozy Support",
                datetime: date,
                notes: notesupdate,
                isDeleted: false,
              },
            ],
          };
        }
        console.log(releaseid, "release");

        axios
          .patch(`agilesaas_releases?ReleaseId=eq.${releaseid}`, data)
          .then((res) => {
            toast.success("Note has been submitted");
            setInputopen(false);
            Refresh_API_data();
            setNotesUpdate("");
            setShowForm(false);
            // console.log(emailmembers);
            if (emailmembers?.length > 0) {
              const extractPlainText = (htmlString) => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = htmlString;
                return tempDiv.textContent || tempDiv.innerText || "";
              };

              const strippedText = extractPlainText(notesupdate);
              let requrireddata = {
                ClientUserId: emplogin?.[0]?.ClientUserId,
                ClientId: clientid,
                ClientDetails: {
                  Company: userorg?.Company,
                  ContactName: userorg?.ContactName,
                  ContactDesignation: userorg?.ContactDesignation,
                  ContactEmail: userorg?.ContactEmail,
                  ContactPhone: userorg?.ContactPhone,
                },
                DepartmentDetails: emplogin?.[0]?.DepartmentDetails,
                DepartmentCode: null,
                TentantId: "",
                FromSenderId: "no-reply@yozytech.com",
                ToEmailIds: {
                  emailids: emailmembers?.[0],
                },
                CcEmailIds: {
                  emailids: ["agileteam@yozytech.com", "support@yozytech.com"],
                },
                BccEmailIds: "",
                EmailType: "SprintClosealert",
                ProductDetails: {
                  ProdId: "11004",
                  ProdName: "KANBAN",
                  Domain: "KANBAN.yozytech.com",
                },
                EmailSubject: "Manager has tagged you in notes",
                IsSuccess: "Y",
                IsPartiallyFailed: " ",
                SendRetryHistory: "",
                IsActive: " ",
                Status: "",
                EmailTemplateName: "SprintClosealert",
                emailnotify: false,
                webnotify: true,
                EmailTemplateVariables: {
                  xxasignbyxx: "",
                  xxassigndatexx: "",
                  xxnotifytimexx: moment().format("YYYY-MM-DDTHH:mm:ss"),
                  xxprjdisxx: "",
                  xxprjnamexx: "",
                  xxstoryNamexx: "",
                  xxprjpercenxx: "",
                  xxprjstartdatexx: "",
                  xxprjenddataexx: "",
                  xxteamnamexx: "",
                  xxsprintxx: "",
                  xxmanagernamexx: userorg?.ContactName,
                  xxcompanyname: userorg?.Company,
                  xxmanagerdesigxx: "Scrum Master",
                  xxgmailxx: userorg?.ContactEmail,
                  xxphnoxx: userorg?.ContactPhone,
                  webappdescri: `${strippedText}`,
                },
              };

              axios({
                url: `${process.env.REACT_APP_API_BASE_URL}/api/agile/email`,
                method: "post",
                data: requrireddata,
                headers: {
                  origin: process.env.REACT_APP_KANBAN_ORIGIN,
                  "Content-Type": "application/json",
                },
              })
                .then((res) => {
                  console.log(res.data, "mailsend");
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            // console.log(res);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } catch (error) {
      console.log(error);
    }
  }

  // function HandleDelete(id) {
  //   const updatedData = {
  //     ManagerNotes: updatednotedata.map((item) => {
  //       if (item.noteNo === id) {
  //         return { ...item, isDeleted: true };
  //       }
  //       return { ...item, isDeleted: false };
  //     }),
  //   };

  //   axios
  //     .patch(`agilesaas_releases?ReleaseId=eq.${releaseid}`, updatedData)
  //     .then((res) => {
  //       toast.success("Note Deleted");
  //       setInputopen(false);
  //       // Refresh_API_data();
  //       setNotesUpdate("");
  //       setShowForm(false);
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }
  function HandleDelete(id) {
    const updatedData = {
      ManagerNotes: updatednotedata.map((item) =>
        item.noteNo === id ? { ...item, isDeleted: true } : item
      ),
    };

    axios
      .patch(`agilesaas_releases?ReleaseId=eq.${releaseid}`, updatedData)
      .then((res) => {
        toast.success("Note Deleted");
        setInputopen(false);
        setNotesUpdate("");
        setShowForm(false);

        // Refresh the data from API or update the state directly
        Refresh_API_data();
      })
      .catch((e) => {
        console.error(e.response?.data || e.message);
      });
  }

  useEffect(() => {
    if (Array.isArray(updatednotedata) && updatednotedata.length > 0) {
      setShowForm(true);
    }
  }, [updatednotedata]);

  useEffect(() => {
    if (updatednotedata > 0) {
      setShowForm(true);
    }
  }, [updatednotedata]);

  function HanldeEdit(e) {
    setShowForm(true);
    setEdit(true);
    setInputopen(true);
    setNotesUpdate(e.notes);
    setEditData(e.noteNo);
  }

  // const [empnames, setEmpNames] = useState([]);
  // const [teamNames, setTeamNames] = useState([]);
  // axios
  //   .get(`agiless_releases?ClientId=${clientId}`)
  //   .then((res) => {
  //     // console.log(res);
  //     const names = res.data.TeamLeavesConsidered.map((member) => ({
  //       Firstname: member.Firstname,
  //       Lastname: member.Lastname,
  //     }));
  //     setTeamNames(names);
  //   })
  //   .catch((e) => {
  //     console.log(e);
  //   }, []);
  // console.log(teamNames);

  const [showSuggestions, setShowSuggestions] = useState(false); // Suggestion dropdown visibility
  const [suggestions, setSuggestions] = useState([]); // Filtered suggestions
  const [cursorPosition, setCursorPosition] = useState(null); // Cursor position in the editor
  const quillRef = useRef(null); // Reference to the ReactQuill editor
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const handleTextChange = (value) => {
    setNotesUpdate(value);

    // Extract text before the cursor
    const quill = quillRef.current?.getEditor();
    const range = quill?.getSelection();
    const selection = quill?.getSelection();
    if (!selection) return;
    if (range && range.length === 0) {
      const bounds = quill.getBounds(range.index);
      setDropdownPosition({
        top: bounds.top + bounds.height,
        left: bounds.left,
      });
    }
    const index = selection.index;
    const textBeforeCursor = value.slice(Math.max(0, index - 20), index); // 20 chars before cursor

    // Detect @mentions
    const match = textBeforeCursor.match(/@$/); // Match only the "@" symbol at the end
    if (match) {
      // Always display the full employee list
      setSuggestions(employeeList);
      setShowSuggestions(true);
      setCursorPosition(index);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (person) => {
    const quill = quillRef.current?.getEditor();
    const selection = quill?.getSelection();
    const index = selection ? selection.index : cursorPosition;
    const text = quill.getText(); // Use Quill's method to get the current text
    const textBeforeCursor = text.slice(0, index);

    const match = textBeforeCursor.match(/@\w*$/);
    if (!match) return;

    const start = index - match[0].length;

    const updatedText =
      text.slice(0, start) + `@${person} ` + text.slice(index);

    quill.setText(updatedText);

    setTimeout(() => {
      quill.setSelection(start + person.length + 2, 0);
    }, 0);

    // Update the state
    // setNotesData(updatedText);
    setShowSuggestions(false);
  };

  return (
    <div>
      {showForm &&
      (projectRole == "SM" ||
        projectRole == "ITMGR2" ||
        projectRole == "QA" ||
        getProdRole == "KA") ? (
        <>
          <div className="mt-2 d-flex align-items-center">
            <Avatar
              className="progressName mr-2"
              src={
                allImage?.length > 0
                  ? allImage?.filter(
                      (x) => x.teammemberid == User_details?.[0]?.ClientUserId
                    )?.[0]?.image
                  : Unassigned
              }
            />
            <span style={{ color: "black" }}>
              {User_details[0].UserFirstname +
                " " +
                User_details[0].UserLastname}
            </span>
          </div>
          <div className="mt-1 ">
            {/* {!inputopen ? (
              <input
                className="form-control ml-4"
                style={{ width: "97%", border: "1px solid black" }}
                onClick={() => {
                  setInputopen(true);
                  setEdit(false);
                }}
                placeholder="Update your important notes & progress"
              />
            ) : null} */}

            {/* {inputopen ? ( */}
            <form onSubmit={Submit_data} className="d-flex flex-column ml-4">
              <div>
                {/* <Toolbar /> */}
                {/* <ReactQuill
                  className="quill w-100"
                  theme="snow"
                  placeholder="Update your important notes & progress"
                  value={notesupdate || ""}
                  onChange={(e) => setNotesUpdate(e)}
                  modules={modules}
                  formats={formats}
                /> */}
                <div style={{ position: "relative" }}>
                  <ReactQuill
                    ref={quillRef}
                    value={notesupdate}
                    onChange={handleTextChange}
                    placeholder="Type @ to mention someone"
                    theme="snow"
                  />

                  {showSuggestions && (
                    <ul
                      style={{
                        position: "absolute",
                        // top: "50px",
                        // left: "40px",
                        top: dropdownPosition.top + "px",
                        left: dropdownPosition.left + "px",
                        backgroundColor: "white",
                        border: "1px solid gray",
                        listStyle: "none",
                        padding: "5px",
                        zIndex: 10,
                        borderRadius: "4px",
                        maxHeight: "150px",
                        overflow: "scroll",
                      }}
                    >
                      {suggestions.map((person, index) => (
                        <li
                          key={index}
                          style={{
                            cursor: "pointer",
                            padding: "5px",
                          }}
                          onClick={() =>
                            handleSuggestionClick(person?.firstname)
                          }
                        >
                          {person?.firstname}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                  marginTop: "40px",
                }}
              >
                <BootstrapButton
                  onClick={() => {
                    setInputopen(false);
                    setShowForm(false);
                    setNotesUpdate("");
                  }}
                  style={{
                    fontSize: 14,
                    padding: 9,
                    width: 100,
                    height: 40,
                    borderRadius: 8,
                    marginRight: 14,
                    border: "2px solid #5250E5",
                    backgroundColor: "#fff",
                    color: "#5250E5",
                    textAlign: "center",
                    textTransform: "none",
                  }}
                >
                  Cancel
                </BootstrapButton>
                <BootstrapButton
                  type="submit"
                  style={{
                    fontSize: 14,
                    padding: 9,
                    width: 100,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: "#5250E5",
                    color: "#fff",
                    border: "0px solid #5A88F1",
                    textAlign: "center",
                    textTransform: "none",
                  }}
                >
                  {edit ? "Update" : "Submit"}
                </BootstrapButton>
              </div>
            </form>
            {/* ) : null} */}
          </div>{" "}
        </>
      ) : null}
      {updatednotedata?.length == 0 && !showForm ? (
        <span>No updates</span>
      ) : (
        <div>
          {updatednotedata
            ?.sort((a, b) => (a.noteNo < b.noteNo ? 1 : -1))
            ?.filter((t) => !t.isDeleted)
            ?.map((e, i) => (
              <div
                key={i}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  padding: "15px",
                  marginBottom: "10px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <div className="d-flex align-items-center">
                  <Avatar
                    className="progressName mr-2"
                    src={
                      allImage?.length > 0
                        ? allImage.find((x) => x.teammemberid == managerid)
                            ?.image
                        : Unassigned
                    }
                  />
                  <span
                    className="font-weight-bold"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    {e.UpdatedByDetails.FN + " " + e.UpdatedByDetails.LN}
                  </span>
                  <span
                    style={{
                      marginLeft: "10px",
                      color: "#999",
                      fontSize: "12px",
                    }}
                  >
                    {updatemoment(e.datetime)}
                  </span>
                </div>
                <p
                  style={{ color: "#333", fontSize: "14px", margin: "10px 0" }}
                  dangerouslySetInnerHTML={{ __html: e.notes }}
                ></p>
                {(projectRole == "SM" ||
                  projectRole == "ITMGR2" ||
                  projectRole == "QA" ||
                  getProdRole == "KA") && (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <span
                      className="text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => HandleDelete(e.noteNo)}
                    >
                      Delete
                    </span>
                    <span
                      className="text-info"
                      style={{ cursor: "pointer" }}
                      onClick={() => HanldeEdit(e)}
                    >
                      Edit
                    </span>
                  </div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
export default ManagerNotesupdate;
